export const assetDanger = {
  id: 43,
  height: 1086390,
  data: {
    icon: "/imgs/icons/asset/danger.png",
    about:
      "DANGER tokens are rewarded to accounts that own NFTs in The Most Dangerous NFT Game collection on RMRK. These tokens will determine the odds of each token holder in the lottery that will take place in 2022.",
    links: [
      {
        name: "Website",
        url: "https://dangerlottery.com/",
      },
      {
        name: "Twitter",
        url: "https://twitter.com/Dangerous_NFT",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Singular",
        url: "https://singular.rmrk.app/collections/9ea8ca9480f9f6df43-DANGER",
        icon: "/imgs/icons/link-singular.svg",
      },
    ],
  },
};
